const countResources = (providers) => providers.reduce(
  (total, provider) => total + (Number(provider.resource_count) || 0),
  0,
);

export const getProviderSummary = (providers = []) => {
  const total = providers.length;
  const authenticated = providers.filter((provider) => provider.status === 'connected').length;
  const resources = countResources(providers);
  const inventoryCapable = providers.filter((provider) => {
    const capabilities = provider.capabilities || {};
    return capabilities.discover || capabilities.list || capabilities.sync || capabilities.attach_existing;
  }).length;
  const provisioningEnabled = providers.filter((provider) => provider.provisioning?.enabled).length;

  if (total === 0) {
    return {
      primary: 'No providers connected yet',
      secondary: 'Add a provider to authenticate credentials and discover inventory',
      authenticated,
      inventoryCapable,
      provisioningEnabled,
      resources,
    };
  }

  const providerWord = total === 1 ? 'provider' : 'providers';
  const resourceWord = resources === 1 ? 'resource' : 'resources';
  const primary = authenticated === total
    ? `${total} ${providerWord} authenticated`
    : `${authenticated} of ${total} ${providerWord} authenticated`;

  return {
    primary,
    secondary: `${resources} ${resourceWord} discovered · Authentication does not confirm operational access`,
    authenticated,
    inventoryCapable,
    provisioningEnabled,
    resources,
  };
};

export const getProviderReadiness = (provider = {}) => {
  const capabilities = provider.capabilities || {};
  const authenticated = provider.status === 'connected';
  const inventoryAvailable = Boolean(
    capabilities.discover || capabilities.list || capabilities.sync || capabilities.attach_existing,
  );
  const provisioningEnabled = Boolean(provider.provisioning?.enabled);
  const advertisedControls = ['start_stop', 'delete']
    .filter((capability) => capabilities[capability]);

  return {
    authenticated,
    authenticationLabel: authenticated ? 'Credentials authenticated' : 'Credentials not authenticated',
    inventoryAvailable,
    inventoryLabel: inventoryAvailable ? 'Inventory capability available' : 'No inventory capability reported',
    provisioningEnabled,
    provisioningLabel: provisioningEnabled
      ? 'Provisioning enabled'
      : (provider.provisioning?.disabled_reason || 'Provisioning not available'),
    advertisedControls,
    controlsLabel: advertisedControls.length
      ? 'Provider reports control support; access is checked for each resource and action'
      : 'No power or deletion capability reported',
  };
};
